import { CSSProperties, FC, ReactNode } from 'react';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { getCollapsibleHoverRevealStyle } from '@/shared/components/layouts/hoverReveal';

interface SiderHoverActionSlotProps {
    children: ReactNode;
    gap?: CSSProperties['marginInlineStart'];
    style?: CSSProperties;
    visible: boolean;
}

const SiderHoverActionSlot: FC<SiderHoverActionSlotProps> = ({ children, gap = '0.25rem', style, visible }) => {
    const { token } = useAntDesignTheme();

    return (
        <div
            aria-hidden={!visible}
            data-sider-hover-action-slot='true'
            style={getCollapsibleHoverRevealStyle(visible, token, { expandedMaxWidth: '1.5rem', gap }, style)}
        >
            {/* Keep grid gutters and the reveal animation from squeezing the action's icon. */}
            <span style={{ alignItems: 'center', display: 'inline-flex', flex: 'none' }}>{children}</span>
        </div>
    );
};

export default SiderHoverActionSlot;
